module.exports = __webpack_public_path__ + "img/shops_unselected.c599c7ac.svg";